export const en = {
  copyPrompt: 'Copy as prompt',
  openIn: 'Open in',
  cursor: 'Cursor',
  claudeCode: 'Claude Code',
  codex: 'Codex',
  vsCode: 'VS Code',
  openCursor: 'Open Cursor',
  openClaude: 'Open Claude Code',
  openCodex: 'Open Codex',
  openVsCode: 'Open VS Code',
  promptCopied: 'Prompt copied to clipboard',
  promptCopyFailed:
    'Clipboard access is unavailable. Select and copy the complete prompt below.',
  promptTooLong:
    'This task is too long to send in an app link. Copy the complete prompt below, open the app, and paste it.',
  taskPrompt: 'Task prompt',
  closePrompt: 'Close'
};
